export default class TagAlertValue {
  label: string
  icon: string

  constructor(data: any) {
    this.label = data.label ?? data.title
    this.icon = data.icon
  }
}
